import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRulerHorizontal, faUsers, faBed, faToilet, faBolt, faShieldAlt, faStar } from '@fortawesome/free-solid-svg-icons';
import TripAdvisorBrand from '../../../images/HomePage/MrSea2025_TripAdvisorBrand.png';
import TripAdvisorIcon from '../../../images/HomePage/MrSea2025_TripAdvisorIcon.svg';
import BoatLeadForm from '../../forms/boats/BoatLeadForm';
import '../../styles/boat/BoatPage.css';

const BoatDetailsTwoColSection = ({ boat, formData, errors, handleChange, handleSubmit, isSubmitting, extraBelowNote }) => {
  const [descExpanded, setDescExpanded] = useState(false);
  const handleReadMore = () => setDescExpanded(true);

  const handleBookNowClick = (e) => {
    e.preventDefault();
    const bookingForm = document.getElementById('boat-booking-form');
    if (bookingForm) {
      bookingForm.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="boat-details-two-col-section">
      <div className="boat-details-two-col-section__content">
        
        <div className="boat-details-two-col-section__left">
          <div className="boat-details-two-col-section__left-top">
          <span className="boat-details-two-col-section__category">
            {boat.category?.name?.toUpperCase() || 'BOAT'}
          </span>
          <h2 className="boat-details-two-col-section__name">{boat.name}</h2>
          {boat.description && (
            <>
              <div className={`boat-details-two-col-section__description${!descExpanded ? ' boat-details-description--clamp' : ''}`}>{boat.description}</div>
              {!descExpanded && (
                <div>
                  <span className="boat-details-description__readmore" onClick={handleReadMore}>Read more</span>
                </div>
              )}
            </>
          )}

          <div className="boat-details-two-col-section__specs">
            {boat.length && (
              <span title="Length">
                <FontAwesomeIcon icon={faRulerHorizontal} className="boat-details-two-col-section__spec-icon" />
                {boat.length} ft.
              </span>
            )}
            {boat.capacity && (
              <span title="Capacity">
                <FontAwesomeIcon icon={faUsers} className="boat-details-two-col-section__spec-icon" />
                {boat.capacity} ppl.
              </span>
            )}
            {boat.staterooms && (
              <span title="Staterooms">
                <FontAwesomeIcon icon={faBed} className="boat-details-two-col-section__spec-icon" />
                {boat.staterooms}
              </span>
            )}
            {boat.bathrooms && (
              <span title="Bathrooms">
                <FontAwesomeIcon icon={faToilet} className="boat-details-two-col-section__spec-icon" />
                {boat.bathrooms}
              </span>
            )}
          </div>
          </div>
          {/* Mobile Book Now Button - Only visible on mobile */}
          <div className="boat-details-mobile-book-now">
            <a href="#boat-booking-form" className="button" onClick={handleBookNowClick}>
              Book Now
            </a>
          </div>
          {(boat.discount_price || boat.price) && (
            <div className="boat-details-price-block">
              <span className="boat-details-price-from">FROM</span>
              <div className="boat-details-price-row">
                {boat.discount_price ? (
                  <>
                    <span className="boat-details-price-discount">${Number(boat.discount_price).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}</span>
                    {boat.price && (
                      <span className="boat-details-price-regular">${Number(boat.price).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}</span>
                    )}
                  </>
                ) : (
                  <span className="boat-details-price-main">${Number(boat.price).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}</span>
                )}
              </div>
            </div>
          )}
          {/* FOMO badge */}
          {(boat.discount_price || boat.price) && (
            <div className="boat-details-fomo">
              <FontAwesomeIcon icon={faBolt} className="boat-details-fomo__icon animate-bounce" />
              <span className="boat-details-fomo__text">Exclusive offer for a limited time!</span>
            </div>
          )}

          {boat.note && (
            <div className="boat-details-note">
              <strong>{boat.note}</strong>
            </div>
          )}
          {extraBelowNote}
        </div>

        <div className="boat-details-two-col-section__right-wrapper">
          <div className="boat-details-two-col-section__right" id="boat-booking-form">
            <p className="boat-lead-intro">
              Please note this is only a request. We will contact you to finalize your booking.
            </p>
            <BoatLeadForm formData={formData} errors={errors} handleChange={handleChange} />
            {errors.submit && <span className="error-message">{errors.submit}</span>}
            <div className="boat-lead-privacy-assurance">
              <FontAwesomeIcon icon={faShieldAlt} />
              <span>We won't share your data.</span>
            </div>
            <div className="boat-lead__buttons">
              <button className="button" onClick={handleSubmit} disabled={isSubmitting}>
                {isSubmitting ? 'Sending...' : 'Send Inquiry'}
              </button>
            </div>
            {/* Barra de reviews dentro de la columna derecha, debajo del botón */}

          </div>
            <div className="boat-details-reviews-bar">
              <span className="boat-details-reviews-bar__text">
                Rated
                <span className="boat-details-reviews-bar__stars">
                  {[...Array(5)].map((_, i) => (
                    <FontAwesomeIcon key={i} icon={faStar} className="boat-details-reviews-bar__star" />
                  ))}
                </span>
                by 100+ happy users on
                <a
                  className="boat-details-reviews-bar__link"
                  href="https://www.tripadvisor.com.ar/Attraction_Review-g34438-d15060176-Reviews-Mr_Sea_Boat_Rentals-Miami_Florida.html"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={TripAdvisorIcon} alt="TripAdvisor icon" className="boat-details-reviews-bar__tripadvisor-brand" />
                  <span className="boat-details-reviews-bar__tripadvisor-text">TripAdvisor</span>
                </a>
              </span>
            </div>
        </div>
      </div>
    </section>
  );
};

export default BoatDetailsTwoColSection; 